<section class="background-color-nearwhite">
    <div class="container">
        <div class="welcome">
            <h2>
                <span class="title" [innerHTML]="title$ | async"></span>
                <span class="name" [innerHTML]="firstName$ | async"></span>
                <span [innerHTML]="lastName$ | async"></span>.
            </h2>
        </div>
        <div class="boxes">
            <div class="textbox teaser">
                <div class="large" [innerHTML]="text$ | async"></div>
            </div>
        </div>
    </div>

    <div class="container" *ngIf="catalogs$ | async as catalogs">
        <h2 [innerHTML]="titleCatalog$ | async"></h2>
        <da-catalog-list [catalogs]="catalogs"></da-catalog-list>
    </div>
</section>
<section class="background-color-white" *ngIf="!(isPartnerPage$ | async)">
    <da-teaser-boxes-container [data]="'landing.teaserBoxes' | translate"></da-teaser-boxes-container>
</section>
<section class="background-color-nearwhite">
    <div class="container">
        <h2 [innerHTML]="titleUpcoming$ | async"></h2>
        <ng-container *ngIf="!(loading$ | async); else loader">
            <ng-container *ngIf="coursesFiltered$ | async as coursesFiltered; else noCourses">
                <ng-container *ngIf="coursesFiltered && coursesFiltered.length > 0">
                    <div class="courses">
                        <div *ngFor="let course of coursesFiltered">
                            <da-my-course-item
                                *ngIf="course"
                                [course]="course"
                                [status]="categories$ | async"
                                [testResults]="testResults$ | async"
                                [mycourses]="coursesFiltered$ |async"
                            ></da-my-course-item>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="coursesFiltered$ | async as coursesFiltered">
            <ng-container *ngIf="coursesFiltered.length <= 0">
                <div class="intro" [innerHTML]="'courses.noCoursesAvailable' | translate"></div>
            </ng-container>
        </ng-container>
    </div>
</section>

<ng-template #loader>
    <section>
        <div id="loader-screen" class="drg-loading-container">
            <i class="loading-icon"></i>
            <i class="loader-shadow"></i>
        </div>
    </section>
</ng-template>

<ng-template #noCourses>
    <section>
        <div class="intro" [innerHTML]="'courses.noCoursesAvailable' | translate"></div>
    </section>
</ng-template>
